import { getRemoteConfig } from './getRemoteConfig';
import type { RemoteConfigKey } from './types';
import { useIsFeatureFlagLoaded } from './useIsFeatureFlagLoaded';

export const useRemoteConfig = <Key extends RemoteConfigKey>(key: Key) => {
  const isLoaded = useIsFeatureFlagLoaded();
  if (!isLoaded) return;

  return getRemoteConfig(key);
};
